import { get } from 'lodash'

export function createLinkElementThenDownloadFile(data, customFileName = null) {
  const href = URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = href
  if (typeof customFileName === 'string') {
    link.setAttribute('download', customFileName)
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export function getDownloadFileNameFromHeaders(headers) {
  const contentDisposition = headers['content-disposition']
  if (typeof contentDisposition !== 'string') {
    return null
  }
  return get(contentDisposition.split('filename='), 1)
}
